
import requests from "./httpService";

const RezorpaySettingServices = {

  getRezorpaySettingDetail: async () => {
    return requests.get("/razorpay-setting");
  },

  createRezorpaySetting: async (payload) => {
    return requests.post("/razorpay-setting", payload);
  },

  // PATCH: Update an existing account
  updateRezorpaySettingDetail: async (id, payload) => {
    return requests.patch(`/razorpay-setting/${id}`, payload);
  },

  activateRezorpaySetting: async (id) => {
    return requests.patch(`/razorpay-setting/${id}/activate`);
  },

  // DELETE: Delete an account
  deleteRezorpaySetting: async (id) => {
    return requests.delete(`/razorpay-setting/${id}`);
  },
};

export default RezorpaySettingServices;
